/**
 * Bump REACT_APP_QURAN_DATA_VERSION when static Quran JSON changes (deploy) so
 * localStorage + Cache Storage are invalidated (see quranCacheMigration.js).
 * Also bump the matching QURAN_DATA_VERSION constant in public/sw.js.
 * Defaults to "2" for local/dev when env is unset.
 */
export const QURAN_DATA_VERSION =
  (typeof process !== 'undefined' &&
    process.env &&
    process.env.REACT_APP_QURAN_DATA_VERSION) ||
  '2';
